/**
 * Built-in translations for text that's not available from settings
 *
 * This provides fallback translations for UI elements that are not part
 * of the configurable translations from the API settings.
 *
 * To add new translations:
 * 1. Add the key to the BuiltInTranslations interface
 * 2. Add translations for all supported languages in BUILT_IN_TRANSLATIONS
 */

export interface BuiltInTranslations {
  materialAndOrigin: string;
  loading: string;
  // Add more translations here as needed
  // Example: sizeGuide: string;
  // Example: shippingInfo: string;
}

export interface BuiltInTranslationMap {
  EN: BuiltInTranslations;
  DE: BuiltInTranslations;
  FI: BuiltInTranslations;
}

export const BUILT_IN_TRANSLATIONS: BuiltInTranslationMap = {
  EN: {
    materialAndOrigin: 'Material and origin',
    loading: 'Loading...',
    // Add English translations here
  },
  DE: {
    materialAndOrigin: 'Material und Herkunft',
    loading: 'Wird geladen…',
    // Add German translations here
  },
  FI: {
    materialAndOrigin: 'Materiaali & alkuperä',
    loading: 'Ladataan...',
    // Add Finnish translations here
  },
};

/**
 * Get built-in translation for a given key and language
 */
export const getBuiltInTranslation = (key: keyof BuiltInTranslations, language: string = 'EN'): string => {
  const normalizedLanguage = language.toUpperCase() as keyof BuiltInTranslationMap;

  // Check if the language is supported
  if (normalizedLanguage in BUILT_IN_TRANSLATIONS) {
    return BUILT_IN_TRANSLATIONS[normalizedLanguage][key];
  }

  // Fallback to English if language is not supported
  return BUILT_IN_TRANSLATIONS.EN[key];
};
